// Core
import React from "react";

// Styles
import "./styles.scss";

//redux
import { useDispatch } from "react-redux";
import { markNotificationAsRead } from "../../Redux/Slices/Common/notificationSlice";
import closeIcon from "../../Assets/Images/closeIcon.svg"

const Notifications = ({ notifications = [], onClose }) => {
  const dispatch = useDispatch();

  const handleUnmount = () => {
    // Mark all notifications as read when the component unmounts
    notifications.forEach((notification) => {
      if (!notification.is_read) {
        dispatch(markNotificationAsRead(notification.notification_id));
      }
    });
  };

  // Call the handleUnmount function when the component is unmounted
  React.useEffect(() => {
    return () => handleUnmount();
  }, []);

  return (
    <div className="notification-container">
      <div className="notifications-box">
        <div className="notifications-header">
          <h4>Notifications ({notifications.length})</h4>
          <img src={closeIcon} className="closeNotification" onClick={onClose} />
        </div>

        {notifications.length === 0 ? (
          <p className="no-notifications-message">No notifications</p>
        ) : (
          <ul className="notifications-list">
            {notifications.map((notification, index) => (
              <li
                key={notification.notification_id}
                className={
                  notification.is_read === false ? "new-notification" : ""
                }
              >
                <div className="notification-message">{notification.body}</div>
                <div className="notification-date">
                  {new Date(notification.createdAt).toLocaleDateString()} at{" "}
                  {new Date(notification.createdAt).toLocaleTimeString()}
                </div>
              </li>
            ))}
          </ul>
        )}
        {/* <a href={`/admin/reports`} className="view-all-notifications">
          View all notifications
        </a> */}
      </div>
    </div>
  );
};

export default Notifications;
